import React from 'react';
import { cls, Column, Grid, Row, Button } from '../../../packages/components';
import './styles/cardEventLiveSearch.scss';
import ProgressBar from '../../../components/ProgressBar';
import WrapperContentPlay from './WrapperContentPlay';
import Utils from '../../../utils/Utils';
import EventTag from '../../../components/PersistentMiniEpg/EventTag';
import { Dates } from '../../../packages/dates/lib/dates';
import EpgPersistence from '../../../AAF/Nepg/EpgPersistence';
import { calculateProgress } from '../../../components/PersistentMiniEpg/Helpers/Utils';
import Metadata from '../../../requests/apa/Metadata';
import getBadges from '../../../utils/Badges';
import Asset from '../../../requests/apa/Asset';
import { NpvrUtil } from '../../../AAF/Npvr/NpvrUtil';
import NpvrUploader from '../../../AAF/Npvr/NpvrUploader';
import { MODAL_PIN } from '../../../actions/modal';
import UtilsSearch from '../UtilsSearch';
import asyncPinObserver from '../../../AAF/Pin/AsyncPinObserver';
import { Pin } from '../../../AAF/Pin/main';
import CardBlockedChannel from './CardBlockedChannel';

const createMarkup =(markup) =>{
    return { __html: markup };
}

const getLeftElement = (contentItem, percent = null, isPlay = false, badges = null) => {
    const { content_type = null, ext_eventimage_name = null, image_small = null} = contentItem;
    const {channel_group = {}, id:groupId = null} = contentItem;
    const group_id = channel_group && channel_group.common ? channel_group.common.id : groupId;

    const blockedChannel = Pin.blockedChannelsList().includes(group_id)

    const image = content_type === "E" ? ext_eventimage_name : image_small
    return (
        <div className={cls(`aaf-main-search-card-event-live-main`)}>
            <div
                className={cls('aaf-main-search-card-event-live-main-container')}
                id={`modal_episode_number_${contentItem.idx_temp || null}`}
                data-id={contentItem.idx_temp || null}
            >
                <div className="aaf-main-search-card-event-live-main-image">
                    {blockedChannel && <CardBlockedChannel/>}

                    <div
                        className={cls('aaf-main-search-card-event-live-main-image-div')}
                        style={{
                            backgroundImage: 'url(' + image + ')',
                            backgroundPosition: `center`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            'background-color': "2d2d2d",
                        }}>
                        {percent && (
                            <div
                                className={cls(
                                    'aaf-main-search-card-event-live-main-image-div-progress-bar',
                                    'aaf-main-search-progress'
                                )}>
                                <div
                                    className={cls(
                                        'aaf-main-search-card-event-live-main-image-div-progress-children'
                                    )}>
                                    <ProgressBar percent={percent} />
                                </div>
                            </div>
                        )}
                    </div>
                    {badges && <div className={`aaf-main-search-card-event-live-main-badge-container`} dangerouslySetInnerHTML={createMarkup(badges)} />}
                </div>
            </div>
        </div>
    );
};

const formatNumber = (number) =>{
    if(!number) return;
    const metaData = Metadata.get('search_numbers_quantity_live_event', 4);
    return Utils.fieldfill('0',number, metaData);
}

const getDatesAndUnixDate = (contentItem = {}) => {
    const {date_begin = null, date_end = null, content_type = null , actual_event = {}} = contentItem
    const dataBeginActualEvent = actual_event.unix_begin ? actual_event.unix_begin : null;
    const dataEndActualEvent = actual_event.unix_end ? actual_event.unix_end : null;
    return {
      date_begin: content_type && content_type === 'E' ? date_begin : dataBeginActualEvent,
      date_end: content_type && content_type === 'E' ? date_end : dataEndActualEvent,
      unix_begin: content_type && content_type === 'E' ? contentItem.unix_begin : dataBeginActualEvent,
      unix_end: content_type && content_type === 'E' ? contentItem.unix_end : dataEndActualEvent,
    }
};

const getDate = (contentItem = {}) => {
    const transformContentItem = getDatesAndUnixDate(contentItem);

    const isEventNow = isNow(transformContentItem);
    let result = '';
    if(!isEventNow){
        const startDate =  EpgPersistence.needsOffset() ? new Dates().unix(transformContentItem.unix_begin).utcOffset(EpgPersistence.needsOffset(), false): new Dates().unix(transformContentItem.unix_begin);
        if(startDate && (typeof startDate.date === 'function') ){
            let monthName =  startDate.format('MMM.');
            if(monthName && (typeof monthName === 'string')){
                monthName =  Utils.capitalize(monthName);
                const day =  startDate.date();
                result = `${day} ${monthName} | `;
            }
        }

    }

    if (transformContentItem && transformContentItem.unix_begin && transformContentItem.unix_end) {
        const dateStart = `${
            EpgPersistence.needsOffset()
                ? new Dates()
                      .unix(transformContentItem.unix_begin)
                      .utcOffset(EpgPersistence.needsOffset(), false)
                      .format('HH:mm')
                : new Dates().unix(transformContentItem.unix_begin).format('HH:mm')
        }`;
        const dateEnd = `${
            EpgPersistence.needsOffset()
                ? new Dates()
                      .unix(transformContentItem.unix_end)
                      .utcOffset(EpgPersistence.needsOffset(), false)
                      .format('HH:mm')
                : new Dates().unix(transformContentItem.unix_end).format('HH:mm')
        }`;
        return `${result}${dateStart} - ${dateEnd}`;
    }
};

const getPercent = (contentItem = {}) => {
    const transformContentItem = getDatesAndUnixDate(contentItem)
    if (transformContentItem && transformContentItem.unix_begin && transformContentItem.unix_end) {
        // const dateStart = EpgPersistence.needsOffset() ? new Dates().unix(contentItem.unix_begin).utcOffset(EpgPersistence.needsOffset(), false) : new Dates().unix(contentItem.unix_begin);
        // const dateEnd = EpgPersistence.needsOffset() ? new Dates().unix(contentItem.unix_end).utcOffset(EpgPersistence.needsOffset(), false) : new Dates().unix(contentItem.unix_end);
        // const start_unix = dateStart.unix();
        // const end_unix = dateEnd.unix();
        return calculateProgress(transformContentItem.unix_begin, transformContentItem.unix_end);
    }
    return false;
};


const getRightElement = (contentItem = {}, isReminder = false, status , asset={}) => {
    const {
      actual_event = {},
      name = ' ',
      title = " ",
      channel_group = {},
      channel_name = '',
      unix_begin = null,
      unix_end = null,
    } = contentItem;

    const {imageSrc = null, label = null} = asset;

    const titleComponent = actual_event.name ? actual_event.name : name ;
    const channelName = actual_event.name ? title : channel_name;
    let channelNumber = ''

    if(channel_group && channel_group.common && channel_group.common.channel_number){
      channelNumber =  channel_group.common.channel_number;
    }else{
        if(contentItem.channel_number){
          channelNumber =  contentItem.channel_number;
        }
    }
    const subtitleName = `${channelNumber} | ${channelName}`;
    const startTime = actual_event.unix_begin ? actual_event.unix_begin : unix_begin
    const endTime = actual_event.unix_end ? actual_event.unix_end : unix_end


    return (
        <Grid className={cls('aaf-main-search-card-event-live-main-right')}>
            <Row className={cls('aaf-main-search-card-event-live-main-right-row')}>
                <Column
                    lg={12}
                    className={cls(
                        'aaf-main-search-card-event-live-main-right-column',
                        'aaf-main-search-card-event-live-main-right-column-title'
                    )}>
                    {UtilsSearch.cutString(titleComponent, 19)}
                </Column>
                <Column
                    lg={12}
                    className={cls(
                        'aaf-main-search-card-event-live-main-right-column',
                        'aaf-main-search-card-event-live-main-right-column-channel-name'
                    )}>
                    {UtilsSearch.cutString(subtitleName)}
                </Column>
                <Column
                    lg={12}
                    className={cls(
                        'aaf-main-search-card-event-live-main-right-column',
                        'aaf-main-search-card-event-live-main-right-column-status-event'
                    )}>
                    <img
                        src={Asset.get('content_data_livechannel_icon', '/images/tvIconSmall.png')}
                        className={cls(
                            'aaf-main-search-card-event-live-main-right-column-status-event-icon'
                        )}
                        alt='icon-live-channel'
                    />
                    <EventTag
                        wrapperId={'modal_1'}
                        spanId={'modal_span_id'}
                        startTime={startTime}
                        endTime={endTime}
                    />
                    {
                        isReminder && <img
                        src={Asset.get('playingLive_programFuture_option_button_reminder', '/images/ic_clock.png')}
                        className={cls(
                            'aaf-main-search-card-event-live-main-right-column-status-event-icon', 'aaf-main-search-card-event-live-main-right-column-status-event-icon-reminder'
                        )}
                        alt='icon-reminder'
                    />
                    }
                    {status  && <img
                        src={imageSrc}
                        className={cls(
                            'aaf-main-search-card-event-live-main-right-column-status-event-icon', 'aaf-main-search-card-event-live-main-right-column-status-event-icon-reminder'
                        )}
                    ></img>
                    }
                </Column>
                <Column
                    lg={12}
                    className={cls(
                        'aaf-main-search-card-event-live-main-right-column',
                        'aaf-main-search-card-event-live-main-right-column-status-date'
                    )}>
                    {getDate(contentItem)}
                </Column>
            </Row>
        </Grid>
    );
};

const isNow = (event) => {
    if (!event) return false;
    return Utils.isDateBetween(event.date_begin, event.date_end);
};

const isFuture = (event) => {
    if (!event) return false;
    const transformContentItem = getDatesAndUnixDate(event)
    return Utils.isCurrentEventFuture({ event: transformContentItem });
};

const isPast = (event) => {
    if (!event) return false;
    return event.date_end && Utils.isDateBetween(event.date_end, Utils.now(true).unix());
};

const onClick = (item, sendPlayLive = null, isPlay = false, sentToPurchase = () =>{}) => {
      UtilsSearch.updateDataStoreSearcher({isFlowSearcherForPin: true});

      if (isPlay) {
        // SI EL EVENTO ES ACTUAL Y TIENE PERMISOS, SE MANDA A REPRODUCIR
        sendPlayLive && (typeof sendPlayLive === 'function') && sendPlayLive(item);

        if(isFuture(item)){
            UtilsSearch.updateDataStoreFlowFuture({isFuture:true, itemClick: item})

            Utils.modalType() !== MODAL_PIN
            && asyncPinObserver.subscribe(UtilsSearch.flowFutureSearcherShowOptions)
        }

      }else{
          const {channel_group = {}, id:groupId = null} = item;
          const group_id = channel_group && channel_group.common ? channel_group.common.id : groupId;
          (typeof sentToPurchase === 'function') && sentToPurchase(group_id);
      }
};

const CardEventLiveSearch = ({ onFocus = null, item = {}, sendPlayLive = null, user = null, isReminder = false, isPlay = false, sentToPurchase= ()=>{}}) => {
    let percent = false;
    let badges = null;
    const status =  NpvrUploader.getAllRecordingStatusByEventId(item.event_alf_id);
    let asset = {};
    if(status && status.recording_status){
        asset = NpvrUtil.getRecordingAsset(status.recording_status);
    }
    if (isNow(item)) {
        // Si es el evento actual, calculamos el porcentaje respecto al now
        percent = getPercent(item);
    }

    const getBadgesLive = (user, proveedor_name, format_types, live_enabled) => {
        if(user){
          badges = getBadges(
              user,
              proveedor_name,
              format_types,
              live_enabled
          );
        }
    }

    const {channel_group = {}, format_types = null, proveedor_name = null, live_enabled = '1'} = item

    if(user && item && channel_group && channel_group.common){
        const {format_types = null, proveedor_name = null, live_enabled = '1'} = channel_group.common;
        getBadgesLive(user, proveedor_name, format_types, live_enabled)
    }else if(user && format_types && proveedor_name && live_enabled){
        getBadgesLive(user, proveedor_name, format_types, live_enabled)
    }


    return (
        <WrapperContentPlay
            children_left={getLeftElement(item, percent, isPlay, badges)}
            children_right={getRightElement(item, isReminder, status, asset)}
            onClick={() => {
                onClick(item, sendPlayLive, isPlay, sentToPurchase);
            }}
            isPlay={isPlay}
            item={item}
            isFuture = {isFuture(item)}
            onFocus = {onFocus}
        />
    );
};

export default CardEventLiveSearch;



// WEBPACK FOOTER //
// ./src/containers/Search/components/CardEventLiveSearch.jsx